import * as React from "react";
import {useCallback, useEffect, useState} from "react";
import search from "../deviceItem/icons/search.svg";
import DeviceItem from "../deviceItem/DeviceItem";

import "./deviceList.scss";
import {observer} from "mobx-react-lite";
import {Box, CircularProgress, Paper} from "@mui/material";
import uiStore from "../../store/UiStore";

interface Device {
    name: string;
    connection_state: string;
    last_active: string;
    id: number;
    tags: object;
    status: string;
}


const DeviceList = ({devices}: any) => {

    const [searchVal, setSearchVal] = useState("");
    const [loading, setLoading] = useState(true);
    const [pingStatuses, setPingStatuses] = useState<Record<string, boolean>>({});

    // Callback for DeviceItem to report its ping status
    const onPingStatusChange = useCallback((deviceId: string, isOnline: boolean) => {
        setPingStatuses(prev => {
            if (prev[deviceId] === isOnline) return prev;
            return { ...prev, [deviceId]: isOnline };
        });
    }, []);

    // Calculate summary based on ping statuses
    const getSummary = () => {
        const result = {total: 0, online: 0, offline: 0};
        devices.data.forEach((item: any) => {
            result.total++;
            const isOnline = pingStatuses[item.id] !== undefined
                ? pingStatuses[item.id]
                : (item.connection_state === 'Connected');
            if (isOnline) {
                result.online++;
            } else {
                result.offline++;
            }
        });
        return result;
    };

  useEffect(() => {
    // Simulate data fetching delay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Hide loader after 3 seconds

    return () => clearTimeout(timer); // Cleanup timeout
  }, []);


    const sumData = getSummary();

    // Filter based on ping status
    let tempData = devices.data.filter((item: any) => {
            const isOnline = pingStatuses[item.id] !== undefined
                ? pingStatuses[item.id]
                : (item.connection_state === 'Connected');
            const pingStatus = isOnline ? "Connected" : "Disconnected";

            if (searchVal === "Connected" || searchVal === "Disconnected") {
                return pingStatus === searchVal;
            }

            if (item.id.includes(searchVal.toLowerCase()) ||
                (item.loco_name && item.loco_name.toLowerCase().includes(searchVal.toLowerCase())) ||
                searchVal === "") {
                return item;
            }
    })


    return (
        /*<Paper data-testid={"table"} >
            {uiStore.getUpdatesDrawerOpen() &&

                    <Box
                      sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.2)",
                        zIndex: 1000, // Ensure it appears above content but below the slider
                        //transition: "all 0.3s ease-in-out",
                        backdropFilter: "blur(0.5px)"
                      }}
                      onClick={() => uiStore.closeUpdatesDrawer()}
                    />
            }*/
        <div className={'devicesContainer'}>
             {uiStore.getUpdatesDrawerOpen() &&

                    <Box
                      sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.2)",
                        zIndex: 1000, // Ensure it appears above content but below the slider
                        //transition: "all 0.3s ease-in-out",
                        backdropFilter: "blur(0.5px)"
                      }}
                      onClick={() => uiStore.closeUpdatesDrawer()}
                    />
            }
            <div className={'searchContainer'}>
                <div className={'deviceSearchSummary'}>
                    <div className={'deviceSearchSummaryLeft'}>
                        <div className={searchVal == ""? 'deviceSearchSummaryLeftItemSelected': 'deviceSearchSummaryLeftItem'}>
                            <div  onClick={() => setSearchVal("")}>Total devices
                            </div>
                            <div>{sumData.total}
                            </div>
                        </div>
                        <div className={searchVal == "Connected"? 'deviceSearchSummaryLeftItemSelected': 'deviceSearchSummaryLeftItem'}>
                            <div  onClick={() => { setSearchVal("Connected");}}>Online Devices
                            </div>
                            <div >{sumData.online}
                            </div>
                        </div>
                        <div className={searchVal == "Disconnected"? 'deviceSearchSummaryLeftItemSelected': 'deviceSearchSummaryLeftItem'}>
                            <div  onClick={() => setSearchVal("Disconnected")}>Offline Devices
                            </div>
                            <div >{sumData.offline}
                            </div>
                        </div>
                    </div>
                    <div className={'deviceSearchSummaryItemRightText'}>Updates every 60 sec
                    </div>
                </div>

                <div className={'deviceSearchBoxContainer'}>
                    <div>
                        <img
                            src={search}
                            alt={"Search"}
                        />
                    </div>
                    <div style={{width: '294px'}}>
                        <div className={'searchPlaceHolder'}>
                            <input autoFocus={true} className={'searchPlaceHolder'}  onChange={e => setSearchVal(e.target.value)}
                                placeholder="Search devices">
                            </input>
                        </div>
                    </div>
                </div>
            </div>

            {loading ? (
                <>
                             <Box


                    sx={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            zIndex: 1001, // Ensure it appears above content but below the slider
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            //transition: "all 0.3s ease-in-out",
                            //backdropFilter: "blur(0.5px)"
                          }}
                >
                      <CircularProgress size={55} thickness={2} color="inherit" />
                </Box>

                </>
              ) : (
                <div className={'devicesList'}>

                    {tempData.map((item: any) => (
                        <DeviceItem key={item.id} item={item} onPingStatusChange={onPingStatusChange} pingStatus={pingStatuses[item.id]}/>
                    ))}
                </div>
            )}


        </div>
      /*  </Paper>*/
    );
}

export default observer(DeviceList);


